import { Order } from 'shell/view-models/order';
import { paginationListToQueryString } from 'system/utils/list-object-to-query-string';
import { OperationObject } from 'system/utils/operation-object-to-query-string';
import { Operation } from 'shell/view-models/operation';
import { FiltersFormNumerators } from './types';

export const transformDataset = (values: FiltersFormNumerators): string => {
  const { orders, ...otherValues } = values;

  const transformedFilters: OperationObject = {};

  if (otherValues.numeratorRegisterType) {
    transformedFilters.tipoRegistro = {
      value: otherValues.numeratorRegisterType,
      operation: Operation.LIKE,
    };
  }

  if (otherValues.year) {
    transformedFilters.anno = {
      value: otherValues.year,
      operation: Operation.LIKE,
    };
  }

  if (otherValues.description) {
    transformedFilters.descrizioneNumeratore = {
      value: otherValues.description,
      operation: Operation.LIKE,
    };
  }

  const ordersToTransform = orders || {};
  const ordersMapped: Order = {};

  if (ordersToTransform.id) {
    ordersMapped.codice = ordersToTransform.id;
  }
  if (ordersToTransform.description) {
    ordersMapped.descrizioneNumeratore = ordersToTransform.description;
  }

  return `?${paginationListToQueryString({
    filters: transformedFilters,
    orders: ordersMapped,
  })}`;
};
